// extracted by mini-css-extract-plugin
module.exports = {"warrantyBadgeButton":"az_KGb","warrantyBadgeText":"az_LGb","smallPadding":"az_MGb"};